import {
  Component,
  DOCUMENT,
  Inject,
  NgZone,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '@app/lib/b2b-stores';
import * as fromDevice from '@app/lib/b2b-stores/device';
import * as fromUser from '@app/lib/b2b-stores/user';

import { RouterUtilService } from '@app/lib/b2b-services/util/router-util.service';
import { Capacitor } from '@capacitor/core';
import { AppSettingsService } from '@app/lib/b2b-services/mobile-app/app-settings.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private store: Store<fromRoot.State>,
    @Inject(DOCUMENT) private document: Document,
    public routerUtilService: RouterUtilService,
    private appSettingsService: AppSettingsService,
    private ngZone: NgZone,
  ) {
    // LoggerService.log('Inside App component');
    this.store.dispatch(fromDevice.InitDeviceInfo({}));
    this.store.dispatch(fromUser.InitUserState({}));
  }

  ngOnInit() {
    // TODO need to load asynchronously in future
    this.setupTawk();
    /*this.document.addEventListener(
      'DOMContentLoaded',
      () => {
        // your code goes here
        LoggerService.warn('Inside DOMContentLoaded event listener');
        this.setupTawk();
      },
      false
    );*/
    /*this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        if (typeof Worker !== 'undefined') {
          // Create a new
          const worker = new Worker(new URL('./app.worker', import.meta.url));
          worker.onmessage = ({ data }) => {
            console.log(`page got message: ${data}`);
          };
          worker.postMessage('hello');
        } else {
          // Web Workers are not supported in this environment.
          // You should add a fallback so that your program still executes correctly.
        }
      }, 5000);
    });*/
  }

  // openChatBox() {
  //   this.setupTawk();
  // }

  onChangeTheme(event): void {
    // console.log('event is ', event.detail);
    if (event.detail.checked) {
      this.document.body.classList.toggle('dark', event.detail.checked);
    } else {
      this.document.body.classList.toggle('dark', event.detail.checked);
    }
  }

  // async openSite(url: string) {
  //   try {
  //     await Browser.open({ url });
  //   } catch (e) {
  //     LoggerService.warn('Error while opening the url in the browser');
  //   }
  // }
  //
  private setupTawk() {
    //environment.production &&
    if (!Capacitor.isNativePlatform()) {
      try {
        const script = this.document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = `
          var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
          (function() {
            var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
            s1.async = true;
            s1.src = "https://embed.tawk.to/5ff6a519a9a34e36b969e00c/1ers1aakl";
            s1.charset = "UTF-8";
            s1.setAttribute("crossorigin", "*");
            s0.parentNode.insertBefore(s1, s0);
          })();
        `;
        this.document.body.appendChild(script);
      } catch (ex) {
        //console.error('Error appending tawk');
        //console.error(ex);
      }
    }
    /*else {
      this.openSite(
        'https://tawk.to/chat/5ff6a519a9a34e36b969e00c/1ers1aakl'
      ).then((r) => console.log('Tawk is opening'));
    }*/
  }

  /*
    private checkMobileAppVersion(): void {
      console.log('in the check mobile version');
      if (!Capacitor.isNativePlatform()) {
        console.log('in the native mobile device');
        this.appSettingsService.checkMobileAppVersion()
      }
    }
  */

  /*openPage(url: string): void {
    this.navController
      .navigateRoot([url], {})
      .then((r) => console.log('Navigating ', r));
  }*/
}

/*
if (typeof Worker !== 'undefined') {
  // Create a new
  const worker = new Worker(new URL('./app.worker', import.meta.url));
  worker.onmessage = ({ data }) => {
    console.log(`page got message: ${data}`);
  };
  worker.postMessage('hello');
} else {
  // Web Workers are not supported in this environment.
  // You should add a fallback so that your program still executes correctly.
}*/
